namespace GeniuzPOS.ReportMasterData {
    export class Report_1411Columns {
        static columnsKey = 'ReportMasterData.Report_1411';
    }
}
